import { TYPES, AppActions } from 'store/modules/app/actions';

interface IAppReducerState {
  isMenuOpen: boolean;
  isShowingModal: boolean;
}

const initialState: IAppReducerState = {
  isMenuOpen: false,
  isShowingModal: false,
};

export const reducerApp = (state = initialState, action: AppActions) => {
  switch (action.type) {
    case TYPES.LOCATION_CHANGE:
      return {
        ...state,
        isMenuOpen: false,
      };
    case TYPES.TOGGLE_MENU:
      return {
        ...state,
        isMenuOpen: !state.isMenuOpen,
      };
    case TYPES.REDUX_RESPONSIVE_STATE: {
      // Close the menu whenever the site is resized.
      // People 99% of the time won't be resizing the window with the menu open
      return {
        ...state,
        isMenuOpen: false,
      };
    }
    case TYPES.SHOW_MODAL:
      return {
        ...state,
        isShowingModal: true,
      };

    case TYPES.HIDE_MODAL:
      return {
        ...initialState,
        isShowingModal: false,
      };

    default:
      return state;
  }
};
